<template>
    <div>
        <KceQuiz v-if="!isUserKCE" :quiz-questions="quizQuestions" :quiz-video="quizVideo" :quiz-header="quizHeader" :get-data="getData" :step-tracker="stepTracker"></KceQuiz>
        <div v-else class="kce-blocked-message">
            <div class="container">
                <div class="kce-blocked-message__wrapper" >
                    <h1>You are already certified. No need to take the quiz again.</h1>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import KceQuiz from './KceQuiz.vue';

export default {
    components: {
        KceQuiz
    },
    data() {
        return {
            quizData: this.getContentByKey("kce-questions"),
            quizHeader: "",
            quizQuestions: [],
            quizVideo: "",
            currentStep:{},
            stepTracker:1,
            isUserKCE:false
        };
    },
    mounted() {
        this.checkForRole();
    let cookie =  this.getCookie("stepTracker");
    if(cookie){
        console.log(cookie)
        this.getData(parseInt(cookie));
    }else{
        document.cookie = "stepTracker=1";
        this.getData(1);
    }
    
    },
    beforeDestroy() { },
    methods: {
         async getData(step){
            //JSON parse twice, once to remove the unneeded characters and once to render as an object
            let data = await this.quizData;
            let dataObj = JSON.parse(JSON.parse(data))
            this.getCurrentStep(dataObj, step);

            this.quizHeader = this.currentStep.header;
            this.quizQuestions = this.currentStep.questions;
            this.quizVideo = this.currentStep.videoLink;
        },
        checkForRole() {
            // alert('Checking for Role');
            let apiToken = $cookies.get('apiToken');
            let usersRoles = apiToken.user.listOfRoles; 
            if (usersRoles.includes('KenoCertifiedExpert')) {
                this.isUserKCE = true;
            }
        },
        // updateStep(step){
        //     console.log("step is",step);
        //     this.getData(step);
        // },
        getCurrentStep(data,step){
            this.stepTracker = step;
            switch (step){
                case 1:
                   this.currentStep = data[0].step1;
                   document.cookie = "stepTracker=" + step;
                    break;

                case 2:
                    console.log("step 2", step)
                     this.currentStep = data[0].step2;
                     document.cookie = "stepTracker=" + step;
                  break;

                case 3:
                    console.log("step 3", step)
                     this.currentStep = data[0].step3;
                     document.cookie = "stepTracker=" + step;
                      break;
                   
                case 4:
                    console.log("step 4", step)
                      this.currentStep = data[0].step4;
                      document.cookie = "stepTracker=" + step;
                      break; 
                case 5:
                      document.cookie = "stepTracker=registration";
                      window.location.replace("/keno-certified-expert/registration");
                      break;                    
            }
        }

    },
    computed: {}
}

</script>
<style scoped></style>